import React from 'react';
import PropTypes from 'prop-types';

const XSType = ({ children, className }) => (
  <div className={`txt-sz-xs avenir-heavy ${className}`}>{children}</div>
);

XSType.defaultProps = {
  className: '',
};

XSType.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default XSType;
